import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Privacy() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-528" data-mp="36huvum9g1r0k">Política de Privacidad</h1>
        <p className="muted" data-id="element-529" data-mp="36gtgw6pb4kdk">Última actualización: 11 de julio de 2026</p>

        <h2 data-id="element-530" data-mp="3k8q7257f0k7b">1. Quiénes somos</h2>
        <p data-id="element-531" data-mp="3k7y8qmmfo8dc">
          Lipolaser Los Angeles LLC, que opera bajo la marca Lipo Laser Los
          Angeles ("nosotros", "nuestro" o "nos"), opera este sitio web (el
          "Sitio").
          Nos comprometemos a proteger la privacidad y la información personal
          que usted comparte con nosotros.
        </p>

        <h2 data-id="element-532" data-mp="3p9430ovqs3oz">2. Información que recopilamos</h2>
        <p data-id="element-533" data-mp="1zswdv70pestx">
          Podemos recopilar información personal que usted proporciona
          directamente, incluyendo:
        </p>
        <ul data-id="element-534" data-mp="1uvmofrdbeh63">
          <li data-id="element-535" data-mp="1uw5x0hh2rt7g">Nombre, número de teléfono y dirección de correo electrónico.</li>
          <li data-id="element-536" data-mp="h3h3pxgjo6wf">
            Información, preferencias o detalles que envía a través de nuestros
            formularios de contacto, solicitud de consulta o comunicación.
          </li>
          <li data-id="element-537" data-mp="q2m5dcnekgct">
            Información técnica y de uso, como dirección IP, tipo de navegador,
            dispositivo, páginas visitadas, tiempo de permanencia y fuente de
            tráfico.
          </li>
        </ul>

        <h2 data-id="element-538" data-mp="zs5macrk2051">3. Cómo usamos su información</h2>
        <p data-id="element-539" data-mp="14rqocw20uolz">Podemos utilizar su información para:</p>
        <ul data-id="element-540" data-mp="14q73st9c1ree">
          <li data-id="element-541" data-mp="14pxez900xqaa">Responder a sus consultas y coordinar o programar citas.</li>
          <li data-id="element-542" data-mp="18una2vmuz0u5">
            Proporcionarle información sobre nuestros servicios y atención
            solicitada.
          </li>
          <li data-id="element-543" data-mp="1dqcbl4ifurt3">
            Enviarle comunicaciones por SMS y correo electrónico, incluyendo
            recordatorios de citas, actualizaciones de cuenta y ofertas
            promocionales, cuando usted haya proporcionado su consentimiento.
          </li>
          <li data-id="element-544" data-mp="mqcqnbqiqudb">
            Mejorar la experiencia del Sitio, nuestros servicios y campañas.
          </li>
          <li data-id="element-545" data-mp="hr9tedgs5sfw">
            Cumplir obligaciones legales y prevenir fraude o uso indebido.
          </li>
        </ul>

        <h2 data-id="element-546" data-mp="vrkndpddzn5a">4. Consentimiento para SMS</h2>
        <p data-id="element-547" data-mp="qr6e6401u75o">
          Al proporcionar su número de teléfono y otorgar su consentimiento a
          través de nuestros formularios del Sitio, usted acepta recibir
          mensajes de texto de Lipolaser Los Angeles LLC relacionados con
          recordatorios
          de citas, actualizaciones de cuenta y ofertas promocionales. La
          frecuencia de los mensajes puede variar. Pueden aplicarse tarifas de
          mensajes y datos.
        </p>
        <p data-id="element-548" data-mp="1affh9934rxjy">
          El consentimiento para recibir mensajes de texto no es una condición
          para comprar servicios. Puede cancelar los mensajes SMS en cualquier
          momento respondiendo <strong data-id="element-549" data-mp="1jgwxqskga196">STOP</strong>. Para recibir ayuda,
          responda <strong data-id="element-550" data-mp="230ud2ocdo6dn">HELP</strong> o escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-551" data-mp="2325ewim9j424">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-552" data-mp="1t3g6dgg9avyj">5. Cookies y tecnologías de seguimiento</h2>
        <p data-id="element-553" data-mp="1t2y3w2303li6">
          Nuestro Sitio puede utilizar cookies y tecnologías de seguimiento
          similares para mejorar la experiencia del usuario, analizar tráfico,
          medir el rendimiento de campañas y personalizar publicidad. Puede
          controlar las preferencias de cookies a través de la configuración de
          su navegador. También utilizamos herramientas como Meta Pixel para
          analizar la efectividad de nuestra publicidad.
        </p>

        <h2 data-id="element-554" data-mp="1fculxnb5mdyj">6. Cómo compartimos información</h2>
        <p data-id="element-555" data-mp="1f9gjkf2hq4r3">
          No vendemos su información personal. Podemos compartir información
          limitada con proveedores de servicios que nos ayudan a operar nuestro
          negocio, como plataformas de CRM, comunicaciones, alojamiento,
          análisis y publicidad, o con autoridades cuando la ley lo exija.
        </p>
        <p data-id="element-556" data-mp="tasppdesq4m1">
          <strong data-id="element-557" data-mp="tb2gh37o0fss">
            No vendemos, alquilamos ni compartimos su número de teléfono móvil
            ni la información de consentimiento para SMS con terceros o
            afiliados para fines de marketing. Los datos de consentimiento y
            opt-in del originador de mensajes de texto no se compartirán con
            terceros.
          </strong>
        </p>

        <h2 data-id="element-558" data-mp="al478js4sgnk">7. Seguridad de datos</h2>
        <p data-id="element-559" data-mp="ak1l0p5r72dz">
          Implementamos salvaguardas administrativas, técnicas y físicas
          razonables para proteger su información personal contra acceso,
          divulgación, alteración o uso indebido no autorizado. Sin embargo,
          ningún método de transmisión por internet o almacenamiento electrónico
          es completamente seguro.
        </p>

        <h2 data-id="element-560" data-mp="1v067yg0jkqew">8. Sus derechos y opciones</h2>
        <p data-id="element-561" data-mp="1v17i8i9qh8vk">Usted puede:</p>
        <ul data-id="element-562" data-mp="1uyv5cjiu1opd">
          <li data-id="element-563" data-mp="23honk5a1rw49">
            Cancelar las comunicaciones SMS en cualquier momento respondiendo
            <strong data-id="element-564" data-mp="27ja9eg4k7kql"> STOP</strong>.
          </li>
          <li data-id="element-565" data-mp="27hz4gczdo6xw">
            Cancelar comunicaciones por correo electrónico mediante el enlace de
            cancelación incluido en dichos correos.
          </li>
          <li data-id="element-566" data-mp="2h8trhjkg7ake">
            Solicitar acceso, actualización o eliminación de su información
            personal.
          </li>
          <li data-id="element-567" data-mp="1kjvvjy0yp6ln">Retirar su consentimiento de marketing en cualquier momento.</li>
        </ul>
        <p data-id="element-568" data-mp="1ojnz1wbi0mk5">
          Para ejercer estos derechos, contáctenos directamente usando la
          información de contacto publicada en el Sitio.
        </p>

        <h2 data-id="element-569" data-mp="1tlvdcsjswepn">9. Residentes de California</h2>
        <p data-id="element-570" data-mp="1yivin18ttdfp">
          Los residentes de California pueden tener derechos adicionales bajo
          las leyes de privacidad aplicables, incluyendo el derecho a conocer,
          corregir o solicitar la eliminación de cierta información personal, y
          el derecho a no ser discriminados por ejercer dichos derechos.
        </p>

        <h2 data-id="element-571" data-mp="2k7sbwcmjpibj">10. Información médica</h2>
        <p data-id="element-572" data-mp="2fase0ozunlvi">
          El Sitio es informativo y una solicitud de consulta no establece una
          relación médico-paciente. No envíe información médica sensible a menos
          que se lo solicitemos mediante un canal adecuado. La información
          médica protegida, cuando corresponda, se maneja de acuerdo con las
          leyes aplicables.
        </p>

        <h2 data-id="element-573" data-mp="21h14hgm4c1zs">11. Cambios a esta política</h2>
        <p data-id="element-574" data-mp="1wkkf6j36nhl4">
          Podemos actualizar esta Política de Privacidad ocasionalmente. La
          fecha de "Última actualización" al inicio de esta página indica la
          versión vigente.
        </p>

        <h2 data-id="element-575" data-mp="26hykpnnkilyn">12. Contacto</h2>
        <p data-id="element-576" data-mp="26gnivtdonoa6">
          Si tiene preguntas sobre esta Política de Privacidad, sus datos o las
          comunicaciones de Lipolaser Los Angeles LLC, escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-577" data-mp="1du2osl5toy2x">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </> : <>
        <h1 data-id="element-578" data-mp="3u7mn7npkvqk9">Privacy Policy</h1>
        <p className="muted" data-id="element-579" data-mp="3u7wdzdig61r0">Last updated: July 11, 2026</p>

        <h2 data-id="element-580" data-mp="3u9fxdczegsx0">1. Who we are</h2>
        <p data-id="element-581" data-mp="3fj8lxh7t8a5t">
          Lipolaser Los Angeles LLC, doing business as Lipo Laser Los Angeles
          ("we," "us," or "our"), operates this website (the "Site"). We are
          committed
          to protecting your privacy and the personal information you share with
          us.
        </p>

        <h2 data-id="element-582" data-mp="h1mkffo7j6o4">2. Information we collect</h2>
        <p data-id="element-583" data-mp="h0ky2f1qqxr3">
          We may collect personal information you provide directly, including:
        </p>
        <ul data-id="element-584" data-mp="30scsz8zh9qi">
          <li data-id="element-585" data-mp="33ehmr4hpb51">Your name, phone number, and email address.</li>
          <li data-id="element-586" data-mp="71vrhifaozq5">
            Information, preferences, or details submitted through our contact,
            consultation-request, or communication forms.
          </li>
          <li data-id="element-587" data-mp="2rsw85ppvvj7b">
            Technical and usage information, such as IP address, browser type,
            device, pages visited, time spent, and traffic source.
          </li>
        </ul>

        <h2 data-id="element-588" data-mp="3ehmbh5xln90l">3. How we use your information</h2>
        <p data-id="element-589" data-mp="3egupmmtt0pni">We may use this information to:</p>
        <ul data-id="element-590" data-mp="3ag11bscg98u3">
          <li data-id="element-591" data-mp="3afr8lx00snkp">Respond to inquiries and coordinate or schedule appointments.</li>
          <li data-id="element-592" data-mp="3ahvlh4fwcwx4">Provide information about our services and requested care.</li>
          <li data-id="element-593" data-mp="35isfnhs3emo3">
            Send SMS and email communications, including appointment reminders,
            account updates, and promotional offers, when you have provided
            consent.
          </li>
          <li data-id="element-594" data-mp="22bxokxzw6pg">Improve the Site experience, our services, and our campaigns.</li>
          <li data-id="element-595" data-mp="3tdbyn7eits6w">Comply with legal obligations and prevent fraud or misuse.</li>
        </ul>

        <h2 data-id="element-596" data-mp="3of0rj4fm1vsd">4. SMS consent</h2>
        <p data-id="element-597" data-mp="3odplsz2ludym">
          By providing your phone number and giving consent through our Site
          forms, you agree to receive text messages from Lipolaser Los Angeles
          LLC
          related to appointment reminders, account updates, and promotional
          offers. Message frequency may vary. Message and data rates may apply.
        </p>
        <p data-id="element-598" data-mp="x8jc8fp67qx4">
          Consent to receive text messages is not a condition of purchasing
          services. You may opt out of SMS messages at any time by replying
          <strong data-id="element-599" data-mp="16a104k8tkwwd"> STOP</strong>. For help, reply <strong data-id="element-600" data-mp="16b28ui2d57ax">HELP</strong> or email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-601" data-mp="167o6vaxm3040">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-602" data-mp="1g7f3pj9n9r79">5. Cookies and tracking technologies</h2>
        <p data-id="element-603" data-mp="1g63xzdwn29di">
          Our Site may use cookies and similar tracking technologies to improve
          user experience, analyze site traffic, measure campaign performance,
          and personalize advertising. You can control cookie preferences
          through your browser settings. We also use tools such as Meta Pixel to
          analyze the effectiveness of our advertising.
        </p>

        <h2 data-id="element-604" data-mp="1ywlpjf5qiyxa">6. How we share information</h2>
        <p data-id="element-605" data-mp="1rijxlvz64qle">
          We do not sell your personal information. We may share limited
          information with service providers that help us operate our business,
          such as CRM, communications, hosting, analytics, and advertising
          platforms, or with authorities when required by law.
        </p>
        <p data-id="element-606" data-mp="267znl9qvks01">
          <strong data-id="element-607" data-mp="267puhdaja4q4">
            We do not sell, rent, or share your mobile phone number or SMS
            opt-in information with third parties or affiliates for marketing
            purposes. Text messaging originator opt-in data and consent will not
            be shared with any third parties.
          </strong>
        </p>

        <h2 data-id="element-608" data-mp="2k4mplqxoq8ct">7. Data security</h2>
        <p data-id="element-609" data-mp="2p6bzv4d32hzu">
          We implement reasonable administrative, technical, and physical
          safeguards to protect your personal information from unauthorized
          access, disclosure, alteration, or misuse. However, no method of
          internet transmission or electronic storage is completely secure.
        </p>

        <h2 data-id="element-610" data-mp="382ubvjtlmt84">8. Your rights and choices</h2>
        <p data-id="element-611" data-mp="383vp9uy37rt0">You may:</p>
        <ul data-id="element-612" data-mp="33bkl2fwbdjun">
          <li data-id="element-613" data-mp="33b2hszb8i5d8">
            Opt out of SMS communications at any time by replying
            <strong data-id="element-614" data-mp="2z9h8fnxws97s"> STOP</strong>.
          </li>
          <li data-id="element-615" data-mp="2za8sq2m22kir">
            Unsubscribe from email communications through the unsubscribe link
            in those emails.
          </li>
          <li data-id="element-616" data-mp="3r0wspbbztjuu">
            Request access to, an update to, or deletion of your personal
            information.
          </li>
          <li data-id="element-617" data-mp="3mz1w2k50bune">Withdraw marketing consent at any time.</li>
        </ul>
        <p data-id="element-618" data-mp="3i08f2hqihlih">
          To exercise these rights, contact us directly using the contact
          information published on this Site.
        </p>

        <h2 data-id="element-619" data-mp="3d0caag9zpq1v">9. California residents</h2>
        <p data-id="element-620" data-mp="3d3hzrwmj6ty4">
          California residents may have additional rights under applicable
          privacy laws, including the right to know, correct, or request
          deletion of certain personal information and the right not to be
          discriminated against for exercising those rights.
        </p>

        <h2 data-id="element-621" data-mp="2828nwiqxf1cs">10. Medical information</h2>
        <p data-id="element-622" data-mp="28160wlwq5j25">
          This Site is informational, and requesting a consultation does not
          establish a physician-patient relationship. Please do not submit
          sensitive medical information unless we request it through an
          appropriate channel. Protected health information, when applicable, is
          handled in accordance with applicable law.
        </p>

        <h2 data-id="element-623" data-mp="1p3wbmo4pxbcz">11. Changes to this policy</h2>
        <p data-id="element-624" data-mp="1p4ny99gc7yr4">
          We may update this Privacy Policy from time to time. The "Last
          updated" date at the top of this page identifies the current version.
        </p>

        <h2 data-id="element-625" data-mp="1fecvhq8e3vlt">12. Contact</h2>
        <p data-id="element-626" data-mp="1fbgwrzopx2wb">
          If you have questions about this Privacy Policy, your data, or
          Lipolaser Los Angeles LLC communications, please email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-627" data-mp="16d4ydbhm10tb">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </>;
  return <LegalLayout data-id="element-628" data-mp="mswk88mr08ug">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-629" data-mp="wozk17u4nve8">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-630" data-mp="wqkih8jkbyhd">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-631" data-mp="rpwqoknifdm3">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-632" data-mp="15pfnwies94jm">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-633" data-mp="15nus6pgqffk6">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-634" data-mp="1ffhdjemsav0n">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-635" data-mp="1ahftorhjaro4" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-636" data-mp="1ofnmqobg98u0">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-637" data-mp="1kfmxs9qq5f8p">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-638" data-mp="3dxkj4qcrwf4i">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-639" data-mp="3nof8i3lbfuu6">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}